import { render, staticRenderFns } from "./SeleccionSubTab.vue?vue&type=template&id=65bb6677&"
import script from "./SeleccionSubTab.vue?vue&type=script&lang=js&"
export * from "./SeleccionSubTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports